/**
 * Status chip for bulk RMA troubleshooting tables. Owns status-to-color mapping.
 */
import Chip, { CHIP_COLORS } from '../../../../../../components/chip/chip';

interface IBulkRmaStatusChipProps {
    status: string;
    label: string;
}

const STATUS_CHIP_COLOR_MAP: Record<string, CHIP_COLORS> = {
    processing: CHIP_COLORS.BLUE,
    running: CHIP_COLORS.BLUE,
    allocated: CHIP_COLORS.BLUE,
    completed: CHIP_COLORS.GREEN,
    succeeded: CHIP_COLORS.GREEN,
    queued: CHIP_COLORS.PENDING,
    pending: CHIP_COLORS.PENDING,
    blocked: CHIP_COLORS.ORANGE,
    failed: CHIP_COLORS.RED,
    error: CHIP_COLORS.RED,
    cancelled: CHIP_COLORS.CANCELLED,
};

const BulkRmaStatusChip: React.FC<IBulkRmaStatusChipProps> = ({ status, label }) => (
    <Chip
        label={label}
        color={STATUS_CHIP_COLOR_MAP[status] ?? CHIP_COLORS.DEFAULT}
    />
);

export default BulkRmaStatusChip;
